module.exports = __webpack_public_path__ + "static/img/fun4.d663d8e5.png";